import * as React from 'react'

interface IPModalContext {}

const { Provider, Consumer } = React.createContext<IPModalContext>({})

export { Provider, Consumer }
